<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏来源日报</h1>
        <div class="block" >
            <span >游戏名称：</span>
            <el-select v-model="queryData.gameIds" multiple filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in gameList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <span class="demonstration">日期：</span>
            <el-date-picker
                    v-model="queryData.timeDate"
                    type="daterange"
:clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <span >渠道：</span>
            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable placeholder="请选择">
                <el-option value="" label="全部"></el-option>
                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="queryData.subChannelId"  @change="selectSubChannel($event)" clearable placeholder="请选择" >
                <el-option value="" label="全部"></el-option>
                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id" :value="item.subChannel"></el-option>
            </el-select>
            <span >板块名称：</span>
            <el-select v-model="queryData.plateId" clearable  filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in showPlateStyles"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <el-button  type="primary" class="margin-left-10"  @click="query" >查询</el-button>
            <el-button  type="primary" @click="exportExcel()" >导出报表</el-button>
        </div>

        <h1>
            <el-table border :data="plateGameReport"
                      :header-cell-style="{background:'#282828'}"
                      ref="filterTable"
                      @sort-change='sortChange'
                      max-height="820">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="dt" label="日期" sortable='custom'></el-table-column>
                <el-table-column prop="plateName"  label="板块名称" >
                </el-table-column>
                <el-table-column prop="gameName"  label="游戏名称"></el-table-column>
                <el-table-column prop="gameId"  label="游戏ID" sortable='custom'></el-table-column>
                <el-table-column  prop="channelName" label="渠道名称" ></el-table-column>
                <el-table-column  prop="subChannelName" label="子渠道名称"></el-table-column>
                <el-table-column  prop="newUser" label="新增用户数" sortable='custom'></el-table-column>
                <el-table-column  prop="user" label="用户数" sortable='custom'></el-table-column>
                <el-table-column  prop="newSourcePercent" label="新用户点击率" sortable='custom'></el-table-column>
                <el-table-column  prop="totalSourcePercent" label="总用户点击率" sortable='custom'></el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
        channelList,
        searchGameSourceReport,
        downloadData,
        searchPlateList,
        gameSimpleList
    }from "@/http/api";
    import utils from '@/utils'

    export default {
        name: "PlateGameReport",
        data(){
           return{
               gameList:[],
               channelList:[],
               subChannelList:[],
               plateGameReport:[],
               showPlateStyles:[],
               watchTag:'',
               dialogMaterialVisible:false,
               queryData:{
                   gameIds:[],
                   channelId:'',
                   subChannelId:'',
                   plateId:'',
                   timeDate:['',''],
               },
               queryTrueData:{
                   gameIds:[],
                   channelId:'',
                   subChannelId:'',
                   plateId:'',
                   startTime:'',
                   endTime:'',
                   order:null,
                   prop:null
               },
               queryInfo:{
                   pagesize:20,
                   pagenum:1,
                   total:0,
               },
           }
        },
       methods:{
           selectGoodsByChannelId(val){
               this.watchTag = val;
               if(val !== null && val !== '' && val !== undefined  ) {
                   this.subChannelList = this.channelList.filter(channel => channel.id === val )[0].children.filter(subChannel=>subChannel.state===1);
               }else{
                   //渠道未选择时默认全部子渠道
                    // this.subChannelList=[];
                    this.selectSubChannel('');
               }
           },
           selectSubChannel(val){
               // 修改逻辑直接复制 styles
               searchPlateList(val).then(res => { 
                    this.showPlateStyles=res.data.info;
               })
           },
           handleSizeChange(newSize){
               this.queryInfo.pagesize=newSize;
                this.queryPlateGameReportList();
           },
           handleCurrentChange(newPage){
               this.queryInfo.pagenum=newPage;
                this.queryPlateGameReportList();
           },
           query(){
               this.queryInfo.pagenum=1;
               this.queryPlateGameReportList();
           },
           queryPlateGameReportList(){
               if (this.queryData.timeDate===null){
                   this.queryData.timeDate=['',''];
               }
               this.queryTrueData.gameIds=this.queryData.gameIds;
               this.queryTrueData.channelId=this.queryData.channelId;
               this.queryTrueData.subChannelId=this.queryData.subChannelId;
               this.queryTrueData.plateId=this.queryData.plateId;
               this.queryTrueData.startTime= this.queryData.timeDate[0];
               this.queryTrueData.endTime=this.queryData.timeDate[1];
               this.queryTrueData.size=this.queryInfo.pagesize;
               this.queryTrueData.page=this.queryInfo.pagenum;
               //todo order type
               searchGameSourceReport(this.queryTrueData).then(resp=>{
                 this.plateGameReport=resp.data.info.content;
                   this.queryInfo.total=resp.data.info.totalElements;
               });
           },
         exportExcel () {
             let fileName = new Date().toLocaleString()+'游戏来源日报.xlsx';
           downloadData(
               '/data/searchGameSourceReportExcel',
               Object.assign(this.queryTrueData),
               fileName
           )
         },
         sortChange(order){
            this.queryTrueData.order=order.order;
            this.queryTrueData.prop=order.prop;
            this.queryPlateGameReportList();
         }
       },
        watch:{
            watchTag(){
                this.queryData.subChannelId='';
            }
        },
       created(){
        this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
        channelList().then(resp=>{
            this.channelList=resp.data.info;
        });
        gameSimpleList().then(resp=>{
            this.gameList=resp.data.info;
        });
 
        this.queryPlateGameReportList();
        searchPlateList("").then(resp=>{
               this.showPlateStyles=resp.data.info;
           });
       }
    }
</script>

<style scoped>

</style>
